module.exports = __webpack_public_path__ + "img/sheet-8-11-2.719bf43b.png";